module.exports = __webpack_public_path__ + "static/media/marine.74fbfed5.svg";